
export const setAgendamentoModal = (status, dataInfo) => ({
    type: 'SET_AGENDAMENTO_MODAL',
    payload: { status, dataInfo }
})

export const setAgendadosModal = (status, data, dataSelecionada) =>({
    type: 'SET_AGENDADOS_MODAL',
    payload: {status, data, dataSelecionada}
});


export const setAgendamentosPorPeriodoModal = (status, periodo) =>({
    type: 'SET_AGENDAMENTOS_POR_PERIODO_MODAL',
    payload: {status, periodo}
});

export const setAgendamentoInfoModal = (status, agendamento, agendamentosDoDia) => ({
    type: 'SET_AGENDAMENTOINFO_MODAL',
    payload: { status, agendamento, agendamentosDoDia }
})

export const setPreCadastroModal = (status) => ({
    type: 'SET_PRECADASTRO_MODAL',
    payload: { status }
})

export const setNovoFeriadoModal = (status) => ({
    type: 'SET_NOVOFERIADO_MODAL',
    payload: { status }
})

export const setEditarFeriadoModal = (status, feriado) => ({
    type: 'SET_EDITARFERIADO_MODAL',
    payload: { status, feriado }
})

export const setNovoModuloModal = (status) => ({
    type: 'SET_NOVOMODULO_MODAL',
    payload: { status }
})

export const setEditarModuloModal = (status, modulo) => ({
    type: 'SET_EDITARMODULO_MODAL',
    payload: { status, modulo }
})

export const setNovoOrgaoModal = (status) => ({
    type: 'SET_NOVOORGAO_MODAL',
    payload: { status }
})

export const setEditarOrgaoModal = (status,values) => ({
    type: 'SET_EDITARORGAO_MODAL',
    payload: { status,values }
})
export const setEditarServicoModal = (status, servico) => ({
    type: 'SET_EDITARSERVICO_MODAL',
    payload: {status, servico}
})

export const setNovoServicoModal = (status) => ({
    type: 'SET_NOVOSERVICO_MODAL',
    payload: { status }
})

export const setNovoVinculoOrgaoServicoModal = (status) => ({
    type: 'SET_NOVOVINCULOORGAOSERVICO_MODAL',
    payload: { status }
})

export const setRealizarAtendimento = (status) => ({
    type: 'SET_REALIZARATENDIMENTO',
    payload: { status }
})
